export default __webpack_public_path__ + "static/central-reach-e9499cbeddb1e1c9d22871dfd70d8dd1.webp";